import { WorkItem } from '../types';

/* ------------------------------------------------------------------ *
 *  "Meer werk" — de secundaire grid. Ouder / losser werk; niets
 *  weggegooid, alleen sober onderaan gezet. Een item toevoegen =
 *  een entry hieronder.
 * ------------------------------------------------------------------ */

export const moreWork: WorkItem[] = [
  {
    id: 'sumiko',
    title: 'Sumiko',
    subtitle: { nl: 'Theemerk & webshop — rust als product', en: 'Tea brand & webshop — calm as a product' },
    track: 'creeren',
    image: '/images/sumiko-animation.svg',
    liveUrl: 'https://sumiko.vercel.app/',
    year: 2025,
  },
  {
    id: 'fieldworks-atelier',
    title: 'Fieldworks Atelier',
    subtitle: { nl: 'Klimaatbewust kledingstudio-concept', en: 'Climate-conscious clothing studio concept' },
    track: 'creeren',
    image: '/images/work/fieldworks-atelier.webp',
    videoLoop: '/videos/work/fieldworks-atelier.mp4',
    videoPoster: '/videos/work/fieldworks-atelier.jpg',
    liveUrl: 'https://fwa-alpha.vercel.app/',
    year: 2025,
  },
  {
    id: 'farli',
    title: 'Färli',
    subtitle: { nl: 'Eerlijk kosten delen zonder je inkomen te tonen', en: 'Fair cost-splitting without revealing your income' },
    image: '/images/work/farli.webp',
    videoLoop: '/videos/work/farli.mp4',
    videoPoster: '/videos/work/farli.jpg',
    track: 'bouwen',
    liveUrl: 'https://f-rli.vercel.app/',
    year: 2025,
  },
  {
    id: 'atelier-ai',
    title: 'AtelierAI',
    subtitle: { nl: 'Merkdocument voor een indie AI-videostudio', en: 'Brand document for an indie AI video studio' },
    track: 'creeren',
    image: '/images/work/atelier-ai.webp',
    videoLoop: '/videos/work/atelier-ai.mp4',
    videoPoster: '/videos/work/atelier-ai.jpg',
    liveUrl: 'https://atelier-ai-merkdocument.vercel.app/',
    year: 2025,
  },
  {
    id: 'cursorflow',
    title: 'CursorFlow',
    subtitle: { nl: 'Interactieve cursor-tracking met particle-effecten', en: 'Interactive cursor tracking with particle effects' },
    track: 'bouwen',
    image: '/images/cursorflow-animation.svg',
    liveUrl: 'https://cursor-flow-cyan.vercel.app',
    year: 2024,
  },
  {
    id: 'free-resources-documentary',
    title: 'Free Resources Documentary',
    subtitle: { nl: 'Hoe ver kom je met gratis bronnen + AI-upscaling', en: 'How far you get with free resources + AI upscaling' },
    image: '/images/work/free-resources-documentary.webp',
    track: 'creeren',
    video: 'https://www.youtube.com/watch?v=hP9IBnE0HOg',
    year: 2024,
  },
  {
    id: 'ai-album-gen',
    title: 'AI Album Generator',
    subtitle: { nl: 'Betaalbare beeldgenerator met ingebouwde editor', en: 'Affordable image generator with a built-in editor' },
    track: 'bouwen',
    image: '/images/ai-album-gen-animation.svg',
    liveUrl: 'https://ai-album-gen.vercel.app/',
    year: 2023,
  },
  {
    id: 'neural-dreams',
    title: 'Neural Dreams',
    subtitle: { nl: 'Surrealistische korte film met modulaire synths', en: 'Surrealist short film with modular synths' },
    track: 'creeren',
    image: '/images/neural-dreams-animation.svg',
    video: 'https://www.youtube.com/watch?v=0EaSToG7-7I',
    year: 2023,
  },
  {
    id: 'living-posters',
    title: 'Particle Field Bloom',
    subtitle: { nl: 'Interactieve audio-visualizer', en: 'Interactive audio visualizer' },
    track: 'bouwen',
    image: '/images/living-posters-animation.svg',
    liveUrl: 'https://particle-field-bloom.vercel.app/',
    year: 2021,
  },
  {
    id: 'virtual-dj',
    title: 'Virtual DJ Booth',
    subtitle: { nl: 'Web-based mixplatform met real-time audio', en: 'Web-based mixing platform with real-time audio' },
    track: 'bouwen',
    image: '/images/virtual-dj-animation.svg',
    year: 2022,
  },
  {
    id: 'modular-synth',
    title: 'Modular Synth',
    subtitle: { nl: 'Modulaire synthesizer in de browser', en: 'Modular synthesizer in the browser' },
    track: 'bouwen',
    image: '/images/modular-synth-animation.svg',
    year: 2022,
  },
  {
    id: 'codebuddy',
    title: 'CodeBuddy',
    subtitle: { nl: 'Leer programmeren via interactieve games', en: 'Learn to code through interactive games' },
    track: 'bouwen',
    image: '/images/codebuddy-animation.svg',
    liveUrl: 'https://codebuddy-mu.vercel.app/',
    year: 2021,
  },
  {
    id: 'patch-field',
    title: 'Patch Field',
    subtitle: { nl: 'Interactief patch-systeem voor visuele experimenten', en: 'Interactive patch system for visual experiments' },
    track: 'bouwen',
    image: '/images/patch-field-animation.svg',
    liveUrl: 'https://patch-field.vercel.app/',
    year: 2020,
  },
  {
    id: 'blastfield',
    title: 'Blastfield',
    subtitle: { nl: 'Interactieve "Legends"-belevenis', en: 'Interactive “Legends” experience' },
    track: 'bouwen',
    image: '/images/blastfield-animation.svg',
    liveUrl: 'https://blastfield.vercel.app/',
    year: 2020,
  },
  {
    id: 'kartent-circular-webshop',
    title: 'KarTent Circular Webshop',
    subtitle: { nl: 'Webshop rond circulaire kartontechnologie', en: 'Webshop around circular cardboard technology' },
    image: '/images/work/kartent-circular-webshop.webp',
    track: 'bouwen',
    video: 'https://www.youtube.com/watch?v=zC-BARbjyIg',
    year: 2020,
  },
  {
    id: 'washly',
    title: 'Washly',
    subtitle: { nl: 'Merkconcept voor een peer-to-peer wasservice', en: 'Brand concept for a peer-to-peer laundry service' },
    track: 'creeren',
    image: '/images/washly-animation.svg',
    liveUrl: 'https://washly-blond.vercel.app/',
    year: 2019,
  },
  {
    id: 'charge-guard',
    title: 'Charge Guard',
    subtitle: { nl: 'Brandingconcept voor batterijbescherming', en: 'Branding concept for battery protection' },
    track: 'creeren',
    image: '/images/charge-guard-animation.svg',
    liveUrl: 'https://charge-guard.vercel.app/',
    year: 2019,
  },
  {
    id: 'the-sluisbox',
    title: 'The Sluisbox',
    subtitle: { nl: 'CGI-videoconcept — 3D, motion graphics, edit', en: 'CGI video concept — 3D, motion graphics, edit' },
    image: '/images/work/the-sluisbox.webp',
    track: 'creeren',
    video: 'https://www.youtube.com/watch?v=y1FPY6RpBv8',
    year: 2019,
  },
  {
    id: 'maya-character-creation',
    title: 'Maya Character Creation',
    subtitle: { nl: '3D-character & animatie — groei in 3D-werk', en: '3D character & animation — growth in 3D work' },
    image: '/images/work/maya-character-creation.webp',
    track: 'creeren',
    video: 'https://www.youtube.com/watch?v=vrhM9isLsHQ',
    year: 2019,
  },
  {
    id: 'game-of-life',
    title: 'Game of Life',
    subtitle: { nl: 'Conway’s Game of Life-simulator', en: 'Conway’s Game of Life simulator' },
    track: 'bouwen',
    image: '/images/game-of-life-animation.svg',
    liveUrl: 'https://game-of-life-kappa-wine.vercel.app/',
    year: 2018,
  },
];
